import styled from 'styled-components/macro'

export const Toggle = styled.input`
  -webkit-appearance: none;
  position: relative;
  width: 30px;
  height: 16px;
  border-radius: 25px;
  margin-right: 8px;
  background-color: #ccc;
  transition: background-color 0.3s;
  outline: none;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    height: 62.5%;
    width: 33.3%;
    background-color: rgb(255, 255, 255);
    transition: left 0.3s;
  }

  &:checked {
    background-color: green;
  }

  &:checked::after {
    left: 70%;
  }
`
